import { useNotify, useRefresh, useRecordContext } from 'react-admin';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import ArchiveIcon from '@mui/icons-material/Archive';
import { request } from '../../services/request';
import { useOktaAuth } from '../../security/OktaContext';

const PREFIX = 'ArchiveButton';

const classes = {
  archiveButton: `${PREFIX}-archiveButton`,
  archiveIcon: `${PREFIX}-archiveIcon`,
};

const StyledButton = styled(Button)(({ theme }) => ({
  [`&.${classes.archiveButton}`]: {
    zIndex: 3000,
    marginLeft: theme.spacing(1),
  },

  [`& .${classes.archiveIcon}`]: {
    fontSize: 20,
    marginRight: theme.spacing(0.5),
  },
}));

const apiUrl = `${import.meta.env.VITE_API_URL}/v1`;

const ArchiveButton = (props) => {
  const { oktaAuth } = useOktaAuth();
  const record = useRecordContext();
  const refresh = useRefresh();
  const notify = useNotify();

  const handleClick = async () => {
    const archived = true;
    const updatedRecord = { ...record, archived };
    const requestUrl = `${apiUrl}/queues/${record.id}`;
    const AuthorizationString = `Bearer ${oktaAuth.getAccessToken()}`;

    const requestOptions = {
      url: requestUrl,
      method: 'put',
      headers: {
        Accept: 'application/json',
        Authorization: AuthorizationString,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(updatedRecord),
    };

    try {
      await request(requestOptions);
      refresh();
      notify('Post archived', { type: 'success' });
    } catch (err) {
      notify(err.errorData.message, { type: 'warning' });
    }
  };

  return (
    <StyledButton
      color="primary"
      size="small"
      onClick={handleClick}
      className={classes.archiveButton}
    >
      <ArchiveIcon className={classes.archiveIcon} />
      Archive
    </StyledButton>
  );
};

export default ArchiveButton;
